/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { PostCard } from "src/components/Splash/PostCard";
import { PostTemplate } from "src/components/Splash/PostTemplate";
import { AppRoutes } from "src/lib/constants";
import { FUNDING_POST_ATTRS } from "src/pages/meta/blog/funding-2022";
import { SIGNUP_WITH_URBIT_POST_ATTRS } from "src/pages/meta/blog/signup-with-urbit";
import { THE_YEAR_2022_POST_ATTRS } from "src/pages/meta/blog/the-year-2022";

const POSTS = [SIGNUP_WITH_URBIT_POST_ATTRS, FUNDING_POST_ATTRS, THE_YEAR_2022_POST_ATTRS];

export default function Blog() {
  return (
    <PostTemplate leftLink={AppRoutes.Meta} leftLinkText="HOME" rightLink={AppRoutes.Jobs} rightLinkText="JOBS">
      {POSTS.map((post) => (
        <PostCard post={post} key={post.slug} />
      ))}
    </PostTemplate>
  );
}
